/*
 * AiChartPresetLauncher — Bridge zwischen dem globalen AI-Assistant-Menu und
 * der PlantChartsPage. Der Assistant-Button oben im Topbar rendert diese
 * Komponente, sobald der User "Auswertung mit KI zusammenstellen" waehlt.
 *
 * Warum eine Bridge und kein direkter Render-in-PlantChartsPage:
 *   1) Der AI-Button lebt in AppShell, die weiss aber nichts von der Chart-
 *      Seite und schon gar nicht von deren Preset-Apply-Handler.
 *   2) Der Modal muss aber im Erfolgsfall die aktuelle Auswahl der Chart-
 *      Seite ueberschreiben — Preset-Payload (leafIds + settings + range +
 *      aggregation) direkt hydrieren.
 *
 * Loesung: Der Launcher rendert den bestehenden AiPresetModal und feuert
 * beim Uebernehmen ein Window-Custom-Event `hv:ai-chart-preset-apply` mit
 * der akzeptierten Serien-Liste. PlantChartsPage abonniert das Event und
 * ruft ihren internen applyAiSuggestion-Handler auf. Kein Signal-Store noetig,
 * kein Prop-Drilling durch die AppShell.
 */

import { AiPresetModal, type AiPresetApplyPayload } from '../charts/AiPresetModal';

interface Props {
  plantId: string;
  onClose(): void;
}

/** Name des Custom-Events auf `window`. Publisher: dieser Launcher. Subscriber:
 *  PlantChartsPage. Kein anderer Component sollte dieses Event abonnieren. */
export const AI_CHART_PRESET_APPLY_EVENT = 'hv:ai-chart-preset-apply';

/** Detail-Shape des Custom-Events. Exportiert damit die Chart-Seite typed
 *  handlen kann ohne die Payload-Struktur des Modals nachzubauen. */
export type AiChartPresetApplyDetail = AiPresetApplyPayload;

export function AiChartPresetLauncher({ plantId, onClose }: Props) {
  return (
    <AiPresetModal
      plantId={plantId}
      onClose={onClose}
      onApply={(payload) => {
        window.dispatchEvent(new CustomEvent<AiChartPresetApplyDetail>(
          AI_CHART_PRESET_APPLY_EVENT,
          { detail: payload },
        ));
        onClose();
      }}
    />
  );
}
